import httper from '../../common/httper.js'
import Qs from 'Qs'
const http = httper.create('/wx-api/pc')

export default {
  modifyPsw: (data) => http.post('/delivery/changPass', Qs.stringify(data)),
}



// WEBPACK FOOTER //
// ./src/services/index/api.js